export default {
  success: "Form was added successfully",
  successDelete: "Row deleted successfully",
};
